<template>
  <v-row>
    <v-col cols="12" sm="12" md="4" lg="3">
      <v-menu
        v-model="menuStartDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="params.startDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="params.startDate" @input="menuStartDate = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="3">
      <v-menu
        v-model="menuEndDate"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            outlined
            flat
            dense
            background-color="white"
            v-model="params.endDate"
            append-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="params.endDate" @input="menuEndDate = false"></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" sm="12" md="4" lg="2">
      <v-btn v-if="$rbac.can('report.export')" color="success" @click="excel">
        <v-icon>
          mdi-file-excel
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import fileDownload from "js-file-download";
import moment from "moment";

export default {
  name: "working-capital",
  data: () => ({
    params: {
      startDate: moment()
        .startOf("year")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .endOf("months")
        .format("YYYY-MM-DD"),
    },
    menuStartDate: false,
    menuEndDate: false,
  }),
  methods: {
    excel() {
      this.$store.commit("SET_LOADER", true);
      this.$store
        .dispatch("report/workingCapitalExcelV2", this.params)
        .then(response => {
          fileDownload(response.data, `working-capital.xlsx`);
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style></style>
